/**
 * 用户偏好相关类型
 */

export type MainGoal = 'beginner' | 'profit' | 'fast_test' | 'brand_building' | 'custom';
export type BudgetRange = 'under_5k' | '5k_to_15k' | '15k_to_50k' | 'over_50k';
export type ExperienceLevel = 'beginner' | 'intermediate' | 'advanced';
export type TimeExpectation = '3_months' | '6_to_12_months' | '1_to_2_years';

export interface UserPreference {
    id?: number;
    sku?: number;
    sku_name?: string;
    config_name?: string;
    is_default?: boolean;
    main_goal: MainGoal;
    main_goal_display?: string;
    budget_range: BudgetRange;
    budget_range_display?: string;
    experience_level: ExperienceLevel;
    experience_level_display?: string;
    time_expectation: TimeExpectation;
    time_expectation_display?: string;
    custom_requirements?: string;
    created_at?: string;
    updated_at?: string;
}

export const MAIN_GOAL_LABELS: Record<MainGoal, string> = {
    beginner: '新手入门',
    profit: '利润优先',
    fast_test: '快速测款',
    brand_building: '品牌建设',
    custom: '自定义',
};

export const BUDGET_RANGE_LABELS: Record<BudgetRange, string> = {
    under_5k: '$5K以下',
    '5k_to_15k': '$5K-15K',
    '15k_to_50k': '$15K-50K',
    over_50k: '$50K以上',
};

export const EXPERIENCE_LEVEL_LABELS: Record<ExperienceLevel, string> = {
    beginner: '新手',
    intermediate: '中级',
    advanced: '资深',
};

export const TIME_EXPECTATION_LABELS: Record<TimeExpectation, string> = {
    '3_months': '3个月快速回本',
    '6_to_12_months': '6-12个月稳定',
    '1_to_2_years': '1-2年品牌',
};
